import { render, staticRenderFns } from "./SupplierCreate.vue?vue&type=template&id=bb29fc26&scoped=true"
import script from "./SupplierCreate.vue?vue&type=script&lang=js"
export * from "./SupplierCreate.vue?vue&type=script&lang=js"
import style0 from "./SupplierCreate.vue?vue&type=style&index=0&id=bb29fc26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb29fc26",
  null
  
)

export default component.exports